import { cn } from "@utils";
import CloseButton from "@components/elements/CloseButton";
import Icon from "@components/elements/Icon";

const CLASS_NAMES = cn(`
  flex
  items-center
  justify-between
  px-5
  py-3
  border-b

  bg-(--primary-background-color)
  text-(--primary-foreground-color)
  border-black/50
`);

const CONTENT_CLASS_NAMES = cn(`
  flex
  items-center
  gap-2
`);

const TITLE_CLASS_NAMES = cn(`
  text-xl
  font-medium
  leading-none

  text-(--primary-foreground-color)
`);

const ICON_CLASS_NAMES = cn(`
  w-5
  h-5

  text-(--primary-foreground-color)
`);

const defaultProps = {
  title: "Modal",
  onClickCloseButton: () => {},
};

export default function ModalHeader(props) {
  const title = props.title || defaultProps.title;
  const onClickCloseButton = props.onClickCloseButton || defaultProps.onClickCloseButton;

  return (
    <header className={CLASS_NAMES}>
      <div className={CONTENT_CLASS_NAMES}>
        {props.titleStartIcon && (
          <Icon
            iconName={props.titleStartIcon}
            className={ICON_CLASS_NAMES}
          />
        )}

        <div className={TITLE_CLASS_NAMES}>
          {title}
        </div>

        {props.titleEndIcon && (
          <Icon
            iconName={props.titleEndIcon}
            className={ICON_CLASS_NAMES}
          />
        )}
      </div>

      <CloseButton
        className="-mx-1.5"
        onClick={onClickCloseButton}
      />
    </header>
  );
}
